export default __webpack_public_path__ + "static/media/skylark.39ac2a3c.png";